
export default function SuitableFor() {
  const suitable = [
    '農産物直売所・ファーマーズマーケットをよく利用する方',
    '提携給油所で給油する機会が多い方',
    '提携スーパーなど、提携店舗で買い物をする方',
    '提携金融機関口座を既にお持ちの方',
    '地域密着型のサービスを好む方',
    '農業関連の仕事をされている方'
  ];

  const notSuitable = [
    '提携金融機関口座を持っておらず、開設する予定もない方',
    '提携施設を利用する機会がほとんどない方',
    '高還元率（1%以上）を重視する方',
    '都市部に住んでいて提携施設が近くにない方'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-12 text-center">
          地域密着型クレジットカードが向いている人・向いていない人
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-[#F0FFF4] rounded-xl p-8 border-2 border-[#00A040]">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-[#00A040] rounded-full flex items-center justify-center">
                <i className="ri-thumb-up-line text-white text-xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-bold text-[#00A040]">向いている人</h3>
            </div>
            <ul className="space-y-3">
              {suitable.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-check-line text-[#00A040] flex-shrink-0 mt-0.5 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-gray-50 rounded-xl p-8 border-2 border-gray-300">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gray-400 rounded-full flex items-center justify-center">
                <i className="ri-thumb-down-line text-white text-xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-600">向いていない人</h3>
            </div>
            <ul className="space-y-3">
              {notSuitable.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-close-line text-gray-400 flex-shrink-0 mt-0.5 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-gray-600">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
